import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Fab } from '@material-ui/core';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import FilterListIcon from '@material-ui/icons/FilterList';
import { toggleSwitch, setSelectedWhatsAppObservations, setWhatsAppObservationsPopup, toggleWhatsAppFilters } from '../../actions/index';
import { ToggleActions } from '../../constants/constants';
import WhatsAppFilters from './WhatsAppFilters';

const WhatsAppButton = ({ 
    whatsappObservationsMode, 
    popUpMenu, 
    whatsappObservationsPopup, 
    whatsappFilters,
    toggleSwitch, 
    setSelectedWhatsAppObservations, 
    setWhatsAppObservationsPopup,
    toggleWhatsAppFilters 
}) => {
    const handleClick = () => {
        // When activating WhatsApp mode, show loader
        if (!whatsappObservationsMode) {
            toggleSwitch(ToggleActions.LOADING_WHATSAPP_OBSERVATIONS, true);
        }
        
        toggleSwitch(ToggleActions.WHATSAPP_OBSERVATIONS_MODE);
        
        // Close popup and clear selection when toggling off
        if (whatsappObservationsMode) {
            setSelectedWhatsAppObservations([]);
            setWhatsAppObservationsPopup({ show: false, close: false, closeList: false, expanded: false, opacity: 1 });
            // Make sure loader is off when disabling
            toggleSwitch(ToggleActions.LOADING_WHATSAPP_OBSERVATIONS, false);
        }
    };

    const handleFilterClick = (e) => {
        e.stopPropagation();
        toggleWhatsAppFilters();
    };

    const isEmbedMode = typeof window !== 'undefined' && window.embed === true;
    // Hide button when popups are open
    const shouldHide = popUpMenu.show || whatsappObservationsPopup.show;

    return (
        <>
            {!isEmbedMode && !shouldHide && (
                <div>
                    <Fab
                        size="medium"
                        className={`whatsapp-fab ${whatsappObservationsMode ? 'active' : ''}`}
                        onClick={handleClick}
                        title={whatsappObservationsMode ? 'Desactivar modo observaciones de WhatsApp' : 'Activar modo observaciones de WhatsApp'}
                    >
                        <WhatsAppIcon />
                    </Fab>
                    {whatsappObservationsMode && (
                        <Fab
                            size="medium"
                            className={`whatsapp-filter-fab ${whatsappFilters.showFilters ? 'active' : ''}`}
                            onClick={handleFilterClick}
                            title={whatsappFilters.showFilters ? 'Ocultar filtros' : 'Mostrar filtros'}
                        >
                            <FilterListIcon />
                        </Fab>
                    )}
                </div>
            )}
            {whatsappObservationsMode && <WhatsAppFilters />}
        </>
    );
};

function mapStateToProps(state) {
    return {
        whatsappObservationsMode: state.switches.whatsappObservationsMode,
        popUpMenu: state.popUpMenu,
        whatsappObservationsPopup: state.whatsappObservations.popup,
        whatsappFilters: state.whatsappObservations.filters,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleSwitch,
        setSelectedWhatsAppObservations,
        setWhatsAppObservationsPopup,
        toggleWhatsAppFilters,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(WhatsAppButton);


